import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import moment from "moment"

const formBuilderTransactionsListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, payment) => <>{payment?.id}</>,
    },
    {
      text: "Date",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, payment) => (
        <>
          {payment?.created_at?.date
            ? moment(payment?.created_at?.date).format("MMM DD, YYYY")
            : "-"}
        </>
      ),
    },
    {
      text: "Status",
      dataField: "billing_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, payment) => <>{payment?.string_status}</>,
    },
    {
      text: "Refund Status",
      dataField: "refund_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, payment) => (
        <>
          {payment?.refund_string_status || "-"}
          {payment?.partial_refund
            ? ` (Partial - $${payment?.refunded_amount / 100})`
            : ""}
        </>
      ),
    },
    {
      text: "Order Total",
      dataField: "amount",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, payment) => <>${payment?.amount / 100}</>,
    },
    {
      text: "Form Builder",
      dataField: "form_builder_name",
      formatter: (cellContent, payment) => <>{payment?.form_builder_name}</>,
    },
    {
      text: "Name",
      dataField: "user_first_name",
      formatter: (cellContent, payment) => (
        <>{payment?.user_first_name + " " + payment?.user_last_name}</>
      ),
    },
    {
      text: "Email",
      dataField: "user_email",
      formatter: (cellContent, payment) => <>{payment?.user_email || "-"}</>,
    },
  ]
}

export default formBuilderTransactionsListColumns
